import React, { useState, useEffect } from 'react'
import { Link, withRouter } from "react-router-dom"
import styled from 'styled-components'
import logo from '../assets/logo.png'
import { FaExternalLinkAlt } from 'react-icons/fa'

const Header = styled.header`
    color:white;
    position:fixed;
    transition:0.5s;
    top:${props => props.state ? '50px' : 0};
    left:0;
    width:100%;
    height:50px;
    display:flex;
    align-items:center;
    background-color:rgba(20, 20, 20, 0.8);
    z-index:9999;
    box-shadow:0px 1px 5px 2px rgba(0, 0, 0, 0.8);
    p{
        color:#fff;
        font-weight:600;
        font-size:20px;
        line-height:50px;
        text-align:right;
        margin:auto;
        position:fixed;
        opacity:0;
        top:${props => props.state ? '50px' : 0};
        transition:0.5s;
        left:50%;
        transform:translateX(-50%);
        animation: loading1 10s ease-in-out ;
        &:before {
        content: attr(data-text);
        line-height:50px;
        max-width:0%;
        position: absolute;
        overflow: hidden;
        white-space: nowrap;
        color: tomato;
        }
        @keyframes loading1 {
            0% {
                opacity:1;
            }
            90% {
                opacity:1;
            }
            100% {
                opacity:0;
            }
        }
        @keyframes loading {
            0% {
                max-width: 100%;
            }
        }
            }
            @media screen and (max-width:1500px){
            p{
                
                left:unset;
                right:8%;
                transform:translateX(0)
            }
            }
            @media screen and (max-width:1150px){
            p{
                display:none;
               
            }
            }
            @media screen and (max-width:768px){
            margin:auto;
            }
`

const List = styled.ul`
    display:flex;
    margin-left:45px;
    @media screen and (max-width:768px){
      margin:auto;
      width:100%;
    }
`

const Item = styled.li`
    position:relative;
    font-size:20px;
    width:100px;
    height:50px;
    text-align:center;
    border-bottom:3px solid ${props => props.current ? "#3498db" : "transparent"};
    color: ${props => props.current ? '#F5C518' : 'inherit'};
    transition: border-bottom 0.5s ease-in-out ;
    a{height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width:768px){
       font-size:17px;
    }}
    
`
const Seader = styled.header`
    color:white;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:50px;
    align-items:center;
    background-color:rgba(20, 20, 20, 0.8);
    z-index:999;
    box-shadow:0px 1px 5px 2px rgba(0, 0, 0, 0.8);
    opacity:${props => props.state ? '1' : '0'};
    transition:1s all;
    ${Item}{
        width:200px;
        a{
            color:white;
        }
    }
    @media screen and (max-width:768px){
    margin:auto;
    ${Item}{
        width:unset;
        margin:0 auto;
        a{
            color:white;
            font-size:14px;
        }
    }
    }
`
const Image = styled.img`
    box-sizing:border-box;
    display:block;
    width:30px;
    height:25px;
    position:absolute;
    top:60%;
    left:50%;
    transform:translate(-50%,-50%);
    animation:startUp 1s ease-in-out 4;
    transform-origin:top left;
    @media screen and (max-width:768px) {
        animation:unset;
    }
    @keyframes startUp {
        0%{
            transform:rotate(0deg) translate(-50%,-50%)
        }
        5%{
            transform:rotate(20deg) translate(-50%,-50%)
        }
        10%{
            transform:rotate(0deg) translate(-50%,-50%)
        }
        15%{
            transform:rotate(-20deg) translate(-50%,-50%)
        }
        20%{
            transform:rotate(0deg) translate(-50%,-50%)
        }
        25%{
            transform:rotate(20deg) translate(-50%,-50%)
        }
        30%{
            transform:rotate(0deg) translate(-50%,-50%)
        }
        35%{
            transform:rotate(-20deg) translate(-50%,-50%)
        }
        40%{
            transform:rotate(0deg) translate(-50%,-50%)
        }
        100%{
            transform:rotate(0deg) translate(-50%,-50%)
        }
    }

`

const Slink = styled(Link)`
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width:768px){
       font-size:17px;
    }
`

const Headers = ({ location: { pathname }, outsideClick }) => {

    const [state, setState] = useState(false)
    const onClick = (e) => {
        e.preventDefault()
        setState(prev => !prev)
    }
    const onFalse = (e) => {
        e.preventDefault()
        setState(false)
    }
    useEffect(() => {
        setState(false)
    }, [outsideClick])

    return (<>
        <Seader state={state}>
            <List>
                <Item>
                    <a target='_blank' rel='noopener noreferrer' href={'https://junchi86.github.io/koflix'}>
                        <FaExternalLinkAlt style={{ color: 'f5c518', marginRight: '10px' }} />KR Ver.
                </a>
                </Item>
                <Item>
                    <a target='_blank' rel='noopener noreferrer' href={'https://junchi86.github.io/coinExplorer'}>
                        <FaExternalLinkAlt style={{ color: 'f5c518', marginRight: '10px' }} />Coin!
                </a>
                </Item>
                <Item>
                    <a target='_blank' rel='noopener noreferrer' href={'https://junchi86.github.io/index'}>
                        <FaExternalLinkAlt style={{ color: 'f5c518', marginRight: '10px' }} />Momentum
                </a>
                </Item>
            </List>
        </Seader>
        <Header state={state} >
            <List>
                <Item style={{ cursor: 'pointer' }} onClick={onClick}>
                    <Image src={logo} />
                </Item>
                <Item onClick={onFalse} current={pathname === '/' || pathname.indexOf('/movie/') === 0}>
                    <Slink to='/'>
                        Movies
                    </Slink>
                </Item>
                <Item onClick={onFalse} current={pathname.indexOf('/tv/') === 0 || pathname.indexOf('/show/') === 0}>
                    <Slink to='/tv/'>
                        TV
                    </Slink>
                </Item>
                <Item onClick={onFalse} current={pathname.indexOf('/search/') === 0}>
                    < Slink to='/search/'>
                        Search
                    </Slink>
                </Item>
            </List>
            <p id='alert' data-text={'Hey! This is a responsive webApp! (https://junchi86.github.io/max)'}>{'Hey! This is a responsive webApp! (https://junchi86.github.io/max)'}</p>
        </Header ></>
    )
}

export default withRouter(Headers)